const FuelType = {
  Gas: "gas",
  Diesel: "diesel",
};

export default FuelType;
